import { noop } from 'lodash';
import { useCallback, useEffect } from 'react';
import useDebounce from 'hooks/useDebounce';
import { SMALLEST_AD_HEIGHT } from 'constants/ads';

function useAdRenderedCheck(_ref) {
  let {
    targetElement,
    onAdRender = noop
  } = _ref;
  const debouncedOnAdRender = useDebounce(onAdRender);
  const handleMutationObserver = useCallback(() => {
    const adElementHeight = (targetElement === null || targetElement === void 0 ? void 0 : targetElement.clientHeight) || 0;
    debouncedOnAdRender(adElementHeight >= SMALLEST_AD_HEIGHT);
  }, [debouncedOnAdRender, targetElement]);
  useEffect(() => {
    if (!targetElement) return noop;
    const observer = new MutationObserver(handleMutationObserver);
    observer.observe(targetElement, {
      attributes: true,
      childList: true,
      subtree: true
    });
    return () => observer.disconnect();
  }, [handleMutationObserver, targetElement]);
}

export default useAdRenderedCheck;